import { useGetQuery, useLazyGetQuery, usePutMutation } from "slices/api";
import { APPLICATION_DETAILS, APPROVED_APPLICATION_DOCUMENT } from "tagTypes";

export const useApprovedApplicationDocumentsQuery = (
  applicationId,
  query = {}
) =>
  useGetQuery({
    endpoint: `/application/${applicationId}/approved-application-document`,
    query,
    tags: [APPROVED_APPLICATION_DOCUMENT],
  });

export const useLazyApprovedApplicationDocumentsQuery = () => {
  const [approvedApplicationDocuments, data] = useLazyGetQuery();
  const approvedApplicationDocument = async (
    payload,
    applicationId,
    query = {}
  ) =>
    await approvedApplicationDocuments(
      {
        endpoint: `/application/${applicationId}/approved-application-document`,
        query,
        payload: payload || {},
        tags: [APPROVED_APPLICATION_DOCUMENT],
      },
      true
    ).unwrap();
  return [approvedApplicationDocument, data];
};

export const usePutApprovedApplicationDocumentsMutation = () => {
  const [approvedApplicationDocuments, data] = usePutMutation();
  const approvedApplicationDocument = async (
    payload,
    applicationId,
    query = {}
  ) =>
    await approvedApplicationDocuments({
      endpoint: `/application/${applicationId}/upload-application-form`,
      query,
      payload: payload || {},
      toastMessage: "Application document added successfully",
      tags: [APPROVED_APPLICATION_DOCUMENT, APPLICATION_DETAILS],
    }).unwrap();
  return [approvedApplicationDocument, data];
};

//create hook for approved application document verifiction
export const usePutApprovedApplicationDocumentMutation = () => {
  const [approvedApplicationDocument, data] = usePutMutation();
  const updateApprovedApplicationDocument = async (query = {}, payload) =>
    await approvedApplicationDocument({
      endpoint: "/power/application/approve-application-form",
      query,
      payload: payload || {},
      toastMessage: "Application document updated successfully",
      tags: [APPROVED_APPLICATION_DOCUMENT, APPLICATION_DETAILS],
    }).unwrap();
  return [updateApprovedApplicationDocument, data];
};

export const usePutApprovedOtherUtilitiesApplicationDocumentMutation = () => {
  const [approvedApplicationDocument, data] = usePutMutation();
  const updateApprovedApplicationDocument = async (query = {}, payload) =>
    await approvedApplicationDocument({
      endpoint: "/approve-application-form",
      query,
      payload: payload || {},
      toastMessage: "Application document updated successfully",
      tags: [APPROVED_APPLICATION_DOCUMENT, APPLICATION_DETAILS],
    }).unwrap();
  return [updateApprovedApplicationDocument, data];
};
